import { colors, spacing, Typography } from "@procore/core-react";

import EmptyIcon from "media/icons/empty.svg?react";

interface EmptyStateProps {
    title: string;
    message: string;
}

export function EmptyState({ title, message }: EmptyStateProps) {
    return (
        <div
            style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                padding: spacing.lg,
                gap: spacing.md,
            }}
        >
            <EmptyIcon
                style={{
                    width: 96,
                    height: 96,
                }}
            />
            <Typography
                style={{
                    fontSize: "1.1em",
                    fontWeight: "600",
                    color: colors.gray15,
                    marginBottom: spacing.xs,
                }}
            >
                {title}
            </Typography>
            <Typography
                style={{
                    color: colors.gray45,
                    lineHeight: "1.5",
                    maxWidth: "300px",
                }}
            >
                {message}
            </Typography>
        </div>
    );
}
